var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "submit-button",
      class: {
        "submit-button--loading": _vm.loading,
        "submit-button--disabled": _vm.disabled,
      },
      attrs: { type: "button", disabled: _vm.disabled || _vm.loading },
      on: { click: _vm.handleClick },
    },
    [
      _vm.loading
        ? _c("span", { staticClass: "loading-spinner" }, [
            _c("i", { staticClass: "fas fa-spinner fa-spin" }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "button-text" }, [
        _vm._v(_vm._s(_vm.loading ? "Processing..." : _vm.text)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }